// extracted by mini-css-extract-plugin
export default {"placeholder":"FileUploadPlaceholder_placeholder__+RRpQ","container":"FileUploadPlaceholder_container__RkxGH","icon":"FileUploadPlaceholder_icon__PB1Rl"};